import { useFetchFile, UserTypeEnum } from "@cpj-ai/panel-npm-package";
import { User } from "@heroui/react";
import { UserSuggestionType } from "..";

export const NameCell: React.FC<{ jobSeeker: UserSuggestionType["user"] | null }> = ({ jobSeeker }) => {
  const { data: avatarUrl } = useFetchFile({
    urlPath: jobSeeker?.profile?.avatar?.file,
    userType: UserTypeEnum.ADMIN,
  });

  return (
    <User
      name={`${jobSeeker?.firstName && jobSeeker?.firstName} ${jobSeeker?.lastName && jobSeeker?.lastName}`}
      description={jobSeeker?.email}
      avatarProps={{
        src: avatarUrl,
        isDisabled: !avatarUrl,
        classNames: {
          img: "opacity-1",
        },
      }}
    />
  );
};
